<template>
    <b-container>
        <b-form @submit.prevent="onSubmit" class="edit_form edit_form--events">
            <button-row :Buttons="Buttons"></button-row>
            <!-- <b-row class="mt-4">
                <b-col>
                    <b-form-group
                        id="input-group-title"
                        label="Titel"
                        label-for="input-title"
                    >   
                        <b-form-input
                            id="input-title"
                            v-model="edit_event.event_title"
                            required
                            placeholder="Titel"
                        ></b-form-input>
                    </b-form-group>
                </b-col>
            </b-row> -->
            <div :visible="!fetching" v-for="(agenda, agenda_i) in edit_event.event_agenda" :key="agenda_i" class="edit_form__agenda"  >
                <!-- <b-row class="mb-3" v-b-toggle="`collapse_${agenda_i}`"> -->
                <b-row class="mb-3" >
                    <b-col>
                        <h2 class="mt-4 mb-1">Programmpunkt {{ agenda_i + 1 }}</h2>
                        <h3 class="edit_form__agenda_meta">({{edit_event.event_agenda[agenda_i].agenda_date | format_date}} | {{edit_event.event_agenda[agenda_i].agenda_begin}})</h3>
                        <small>Bitte hinterlegen Sie die Informationen zu diesem Programmpunkt</small>
                    </b-col>
                </b-row>
                <!-- <b-collapse :id="`collapse_${agenda_i}`" :visible="agenda_i == 0"> -->
                    <b-row class="mb-3">
                        <b-col>
                            <h3 class="mt-2 mb-1">Termin</h3>
                        </b-col>
                    </b-row>
                    <b-row>
                        <b-col cols="6">
                            <b-form-group
                                :id="`input-group-agenda-date_${agenda_i}`"
                                label="Datum"
                                :label-for="`input-agenda-date_${agenda_i}`"
                            >   
                                <b-form-input
                                    type="date"
                                    :id="`input-agenda-date_${agenda_i}`"
                                    v-model="edit_event.event_agenda[agenda_i].agenda_date"
                                    required
                                    placeholder="Datum"
                                ></b-form-input>
                            </b-form-group>
                        </b-col>
                        <b-col cols="6">
                            <b-form-group
                                :id="`input-group-agenda-begin_${agenda_i}`"
                                label="Uhrzeit"
                                label-for="input-agenda-begin"
                            >   
                                <b-form-input
                                    type="time"
                                    :id="`input-agenda-begin_${agenda_i}`"
                                    v-model="edit_event.event_agenda[agenda_i].agenda_begin"
                                    required
                                    placeholder="Uhrzeit"
                                ></b-form-input>
                            </b-form-group>
                        </b-col>
                    </b-row>
                    <b-row class="mb-3">
                        <b-col>
                            <h3 class="mt-2 mb-1">Veranstaltungsdaten</h3>
                        </b-col>
                    </b-row>
                    <b-row>
                        <b-col>
                            <b-form-group
                                :id="`input-group-agenda-title_${agenda_i}`"
                                label="Titel"
                                :label-for="`input-agenda-title_${agenda_i}`"
                            >   
                                <b-form-input
                                    type="text"
                                    :id="`input-agenda-title_${agenda_i}`"
                                    v-model="edit_event.event_agenda[agenda_i].agenda_title"
                                    required
                                    placeholder="Titel"
                                ></b-form-input>
                            </b-form-group>
                        </b-col>
                    </b-row>
                    <b-row>
                        <b-col>
                            <b-form-group
                                :id="`input-group-agenda-location_${agenda_i}`"
                                label="Location"
                                :label-for="`input-agenda-location_${agenda_i}`"
                            >   
                                <b-form-input
                                    type="text"
                                    :id="`input-agenda-location_${agenda_i}`"
                                    v-model="edit_event.event_agenda[agenda_i].agenda_location"
                                    placeholder="Location"
                                ></b-form-input>
                            </b-form-group>
                        </b-col>
                    </b-row>
                    <b-row>
                        <b-col>
                            <b-form-group
                                :id="`input-group-agenda-street_${agenda_i}`"
                                label="Adresse"
                                :label-for="`input-agenda-street_${agenda_i}`"
                            >   
                                <b-form-input
                                    type="text"
                                    :id="`input-agenda-street_${agenda_i}`"
                                    v-model="edit_event.event_agenda[agenda_i].agenda_street"
                                    placeholder="Straße und Nr."
                                ></b-form-input>
                            </b-form-group>
                        </b-col>
                    </b-row>
                    <b-row>
                        <b-col cols="6">
                            <b-form-group
                                :id="`input-group-agenda-zip_${agenda_i}`"
                                label="PLZ"
                                :label-for="`input-agenda-zip_${agenda_i}`"
                            >   
                                <b-form-input
                                    type="text"
                                    :id="`input-agenda-zip_${agenda_i}`"
                                    v-model="edit_event.event_agenda[agenda_i].agenda_zip"
                                    placeholder="PLZ"
                                ></b-form-input>
                            </b-form-group>
                        </b-col>
                        <b-col cols="6">
                            <b-form-group
                                :id="`input-group-agenda-city_${agenda_i}`"
                                label="Ort"
                                :label-for="`input-agenda-city_${agenda_i}`"
                            >   
                                <b-form-input
                                    type="text"
                                    :id="`input-agenda-city_${agenda_i}`"
                                    v-model="edit_event.event_agenda[agenda_i].agenda_city"
                                    placeholder="Stadt"
                                ></b-form-input>
                            </b-form-group>
                        </b-col>
                    </b-row>
                    <b-row>
                        <b-col>
                            <b-form-group
                                :id="`input-group-agenda-entryfee_${agenda_i}`"
                                label="Eintrittspreis pro Person in €"
                                :label-for="`input-agenda-entryfee_${agenda_i}`"
                            >   
                                <b-form-input
                                    type="text"
                                    :id="`input-agenda-entryfee_${agenda_i}`"
                                    v-model="edit_event.event_agenda[agenda_i].agenda_entryfee"
                                    placeholder="Eintrittspreis"
                                ></b-form-input>
                            </b-form-group>
                        </b-col>
                    </b-row>
                    <b-row>
                        <b-col>
                            <b-form-group
                                :id="`input-group-agenda-intro_${agenda_i}`"
                                label="Beschreibung"
                                :label-for="`input-agenda-intro_${agenda_i}`"
                            >   
                                <b-form-textarea
                                    rows="4"
                                    :id="`input-agenda-intro_${agenda_i}`"
                                    v-model="edit_event.event_agenda[agenda_i].agenda_intro"
                                    placeholder="Beschreibung"
                                ></b-form-textarea>
                            </b-form-group>
                        </b-col>
                    </b-row>
                    <b-row class="mb-3">
                        <b-col>
                            <h3 class="mt-2 mb-1">Eigenschaften</h3>
                        </b-col>
                    </b-row>
                    <b-row>
                        <b-col cols="12">
                            <b-form-group
                                :id="`input-group-agenda-all_${agenda_i}`"
                                :label-for="`input-agenda-all_${agenda_i}`"
                            >   
                                <b-form-checkbox
                                    :id="`input-agenda-all_${agenda_i}`"
                                    v-model="edit_event.event_agenda[agenda_i].agenda_user_all_bool"
                                >Alle dürfen teilnehmen</b-form-checkbox>
                            </b-form-group>
                        </b-col>
                        <b-col cols="12" v-if="!edit_event.event_agenda[agenda_i].agenda_user_all_bool">
                            <b-form-select
                                multiple
                                v-model="edit_event.event_agenda[agenda_i].agenda_user_roles"
                                :options="user_roles"
                                :select-size="3"
                            ></b-form-select>
                        </b-col>
                    </b-row>
                    <b-row>
                        <b-col cols="6">
                            <b-form-group
                                :id="`input-group-agenda-spouse_${agenda_i}`"
                                :label-for="`input-agenda-spouse_${agenda_i}`"
                            >   
                                <b-form-checkbox
                                    :id="`input-agenda-spouse_${agenda_i}`"
                                    v-model="edit_event.event_agenda[agenda_i].agenda_user_spouse_bool"
                                >Partner erlaubt</b-form-checkbox>
                            </b-form-group>
                            <b-form-group
                                :id="`input-group-agenda-guestlist_${agenda_i}`"
                                :label-for="`input-agenda-guestlist_${agenda_i}`"
                            >   
                                <b-form-checkbox
                                    :id="`input-agenda-guestlist_${agenda_i}`"
                                    v-model="edit_event.event_agenda[agenda_i].agenda_user_guestlist_bool"
                                >Teilnehmerliste</b-form-checkbox>
                            </b-form-group>
                        </b-col>
                        <b-col cols="6">
                            <b-form-group
                                :id="`input-group-agenda-guests_${agenda_i}`"
                                :label-for="`input-agenda-guests_${agenda_i}`"
                            >   
                                <b-form-checkbox
                                    :id="`input-agenda-guests_${agenda_i}`"
                                    v-model="edit_event.event_agenda[agenda_i].agenda_user_guests_bool"
                                >Gäste erlaubt</b-form-checkbox>
                            </b-form-group>
                        </b-col>
                    </b-row>
                    <b-row>
                        <b-col>
                            <b-form-group
                                :id="`input-group-agenda-rsvp_${agenda_i}`"
                                label="Zusage erforderlich bis"
                                :label-for="`input-agenda-rsvp_${agenda_i}`"
                            >   
                                <b-form-input
                                    type="date"
                                    :id="`input-agenda-rsvp_${agenda_i}`"
                                    v-model="edit_event.event_agenda[agenda_i].agenda_rsvp_date"
                                    placeholder="Datum"
                                ></b-form-input>
                            </b-form-group>
                        </b-col>
                    </b-row>
                    <b-row class="btn-row py-4" v-if="edit_event.event_agenda.length > 1">
                        <b-col cols="12">
                            <b-btn variant="warning" class="btn-block" type="button" @click.prevent="onDeleteAgenda(agenda_i)">
                                <span class="d-flex align-items-center justify-content-center">
                                    <span><font-awesome-icon :icon="['far', 'trash-alt']" />
                                    Programmpunkt löschen</span>
                                </span>
                            </b-btn>
                        </b-col>
                    </b-row>
                <!-- </b-collapse> -->
            </div>
            <b-row class="mt-4">
                <b-col>
                    <b-btn @click="addAgenda">Programmpunkt hinzufügen</b-btn>
                </b-col>
            </b-row>
            <button-row :Buttons="Buttons" comp_class="pt-4 border-top"></button-row>

            <b-row class="btn-row py-4">
                <b-col  cols="12" style="padding-right: 7px;">
                    <b-btn variant="danger" class="btn-block" type="button" @click.prevent="onDelete">
                        <span class="d-flex align-items-center justify-content-center">
                            <span><font-awesome-icon :icon="['far', 'trash-alt']" />
                            Termin löschen</span>
                        </span>
                    </b-btn>
                </b-col>
            </b-row>
        </b-form>
    </b-container>
</template>

<script>
import Swal from 'sweetalert2';
// import moment from 'moment';
import { mapGetters, mapActions } from "vuex";
import ButtonRowVue from '../components/ButtonRow.vue'
export default {
    name: 'event-edit-cmp',
    components: {
        'button-row': ButtonRowVue,
    },
    // filters: {
    //     format_date(date) {
    //         return moment(date).format('DD.MM.YYYY');
    //     }
    // },
    props: {
    },
    data() {
        return {
            edit_event: { event_agenda: []},
            agenda_obj: {
                agenda_date: '',
                agenda_begin: '',
                agenda_title: '',
                agenda_intro: '',
                agenda_location: '',
                agenda_street: '',
                agenda_zip: '',
                agenda_city: '',
                agenda_country: '',
                agenda_meeting_point: '',
                agenda_rsvp_date: '',
                agenda_user_all_bool: true,
                agenda_user_spouse_bool: true,
                agenda_user_guests_bool: true,
                agenda_user_guestlist_bool: true,
                agenda_user_roles: [],
                agenda_entry_free: 0
            },
        }
    },
    mounted() {
        this.event_id = this.$route.params.Id == "false" ? false : this.$route.params.Id;
        this.fetchUserRoles();
        this.init();
    },
    computed: {
        ...mapGetters('auth', ['loggedIn', 'isActivity']),
        ...mapGetters('events', ['fetching', 'event', 'user_roles']),

        Buttons() {
            const buttons = [
                {
                    title: 'Zurück',
                    to: '/event-list',
                    // to: this.edit_event.event_id ? '/event-list' : '/admin',
                    variant: 'light border',
                    icons: {
                        left: {
                            icon: ['far', 'arrow-left'],
                            visible: true
                        },
                        right: {
                            icon: ['far', 'arrow-right'],
                            visible: false
                        }
                    }
                }
            ]
            buttons.push({
                title: 'Speichern',
                variant: 'primary',
                type: 'submit',
                icons: {
                    left: {
                        icon: ['far', 'arrow-left'],
                        visible: false
                    },
                    right: {
                        icon: ['far', 'arrow-right'],
                        visible: false
                    }
                },
            });
            
            return buttons;
        }
    },
    watch: {
        fetching(newValue) {

            if (newValue == false && this.event_id) {
                this.edit_event.event_agenda = this.event.event_agenda;
                this.edit_event.event_title = this.event.event_title;
                this.edit_event.event_id = this.$route.params.Id;
            }
        }
    },
    methods: {
        ...mapActions('events', ['fetchEvent', 'fetchUserRoles', 'saveEvent', 'deleteEvent', 'deleteAgenda']),
        init() {
            this.addEventListener();
            if (this.event_id) {
                setTimeout(() => {
                    
                    this.fetchEvent(parseInt(this.$route.params.Id));
                }, 500);
            } else {
                this.addAgenda();
            }
        },
        addEventListener() {

            window.LC_Event.$on('deleteEventSuccess', () => {
                Swal.fire({
                    title: 'Erfolg',
                    text: 'Termin wurde erfolgreich gelöscht',
                    icon: 'success',
                    showCancelButton: false,
                    showCloseButton: true,
                    confirmButtonText: 'Ok'
                }).then(() => {
                    this.$router.push('/');
                })
            });

            window.LC_Event.$on('deleteAgendaSuccess', () => {
                this.fetchEvent(this.edit_event.event_id);
                Swal.fire({
                    title: 'Erfolg',
                    text: 'Programmpunkt wurde erfolgreich gelöscht',
                    icon: 'success',
                    showCancelButton: false,
                    showCloseButton: true,
                    confirmButtonText: 'Ok'
                });
            })
        },
        addAgenda() {
            this.edit_event.event_agenda.push(this.agenda_obj);
        },
        onDeleteAgenda(agenda_i) {
            Swal.fire({
                title: "Programmpunkt löschen",
                text: 'Sind Sie sich sicher?',
                icon: 'question',
                showConfirmButton: true,
                showCancelButton: true,
                showCloseButton: true,
                confirmButtonText: 'Programmpunkt löschen',
                cancelButtonText: 'Abbrechen'
            }).then((result) => {
                if(result.value) {
                    // programmpunkt löschen
                    this.deleteAgenda({
                        event_data: {
                            event_id: this.edit_event.event_id,
                            event_agenda_index: agenda_i
                        }
                    })
                }
            })
        },
        onDelete() {
            Swal.fire({
                title: "Termin löschen",
                text: 'Sind Sie sich sicher?',
                icon: 'question',
                showConfirmButton: true,
                showCancelButton: true,
                showCloseButton: true,
                confirmButtonText: 'Termin löschen',
                cancelButtonText: 'Abbrechen'
            }).then((result) => {
                if (result.value) {
                    // termin löschen
                    this.deleteEvent({
                        event_data: {
                            event_id: this.edit_event.event_id
                        }
                    });
                }
            });
        },
        onSubmit() {
            const event_data = this.edit_event;
            this.saveEvent({event_data: event_data})
        },
    }
}
</script>

<style lang="scss">
    @import '../scss/variables';
</style>